import { Extension } from '@tiptap/core';
import { Plugin, PluginKey } from '@tiptap/pm/state';
import { Decoration, DecorationSet } from '@tiptap/pm/view';

import { findPlaceholders } from './placeholders';

const pluginKey = new PluginKey('placeholderHighlight');

interface PlaceholderHighlightOptions {
  /** CSS class (from the CSS module) put on each highlighted placeholder. */
  className: string;
}

/**
 * Paints [missing] and [not attached yet] inside the editor itself. A decoration
 * is computed from the document on every change, so the highlight sits on the
 * same text it describes, wraps with it, and goes the moment the user types the
 * placeholder away. It adds no content: the text stays a plain string.
 */
export const PlaceholderHighlight =
  Extension.create<PlaceholderHighlightOptions>({
    name: 'placeholderHighlight',

    addOptions() {
      return { className: 'placeholder' };
    },

    addProseMirrorPlugins() {
      const { className } = this.options;
      return [
        new Plugin({
          key: pluginKey,
          props: {
            decorations(state) {
              const decorations: Decoration[] = [];
              state.doc.descendants((node, pos) => {
                if (!node.isText || !node.text) return;
                findPlaceholders(node.text).forEach(({ start, end }) => {
                  decorations.push(
                    Decoration.inline(pos + start, pos + end, {
                      nodeName: 'mark',
                      class: className,
                      'data-testid': 'composer-placeholder',
                    })
                  );
                });
              });
              return DecorationSet.create(state.doc, decorations);
            },
          },
        }),
      ];
    },
  });
